// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/thefaceshop_inklipquid.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/promise.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/TexturizerDefault.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/images/layout09-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/images/layout09-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/images/layout09-3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'thefaceshop_inklipquid'; /* 폰트 이름 지정 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}


.section9_container__x9WR6 {
  display: flex;
}

.section9_text-1__EOwPt {
  color: black;
  font-family: 'thefaceshop_inklipquid';
  font-size: 65px;
  letter-spacing: 10px;
}



/* top */
.section9_top__SHJsz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(${___CSS_LOADER_URL_REPLACEMENT_2___}); /* 패턴 이미지 경로 */
  background-size: 200px, 100%, 100px;
  background-repeat: no-repeat, no-repeat ,repeat;
  background-position: right bottom, center , center;
  text-align: center;           /* 텍스트 중앙 정렬 */  
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

/* top */
.section9_top-contents__UHOoF {
  text-align: center;           /* 텍스트 중앙 정렬 */  
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}


.section9_parent__gusmP {
  display: flex;                /* Flexbox로 배치 */
}


/* 자식 div */
.section9_child__ej\\+5e {
  flex: 1 1 40%;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */
  padding: 5%;                /* 내부 여백 */
  text-align: center;           /* 텍스트 중앙 정렬 */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;  
}

.section9_child1__eNmvT {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  transition: all 1s ease-in-out;
}

.section9_child2__5pvFc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  
}

.section9_child3__tGkg2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  
}

.section9_fadeIn__aC1I0 {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1); /* 나타날 때 스케일 1 */
}

.section9_fadeOut__FGHNq {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.9); /* 사라질 때 스케일 0.9 */
}

.section9_textboxA__LVJ-I {
  position: absolute; /* 텍스트들이 같은 위치에 겹치도록 설정 */
  top: 50%;
  left: 50%;
  width : 100%;
  font-size: 24px;
  color: white;
  font-weight: 700;
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.section9_textboxB__Jigxv {
  position: absolute; /* 텍스트들이 같은 위치에 겹치도록 설정 */
  top: 50%;
  left: 50%;
  width : 100%;
  font-size: 14px;
  color: white;
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.section9_textboxAblack__iVPJt {
  color: black;
}

.section9_textboxBblack__-PskW {
  color: black;
}

@media (max-width: 1024px) {
  .section9_child__ej\\+5e {
    height: 100%;
  }
  
  .section9_container__x9WR6 {
    flex-direction: column;
  }

  .section9_image-click__5XmWR {
    width : 40px;
  }

  .section9_textboxA__LVJ-I {
    font-size: 18px;
  }

  .section9_textboxB__Jigxv {
    font-size: 16px;
  }

  .section9_image-logo__OmsBX {
    width : 200px;
  }

  .section9_text-1__EOwPt {
    color: black;
    font-size: 35px;
    letter-spacing: 5px;
    line-height: 0;
  }

  .section9_top__SHJsz {
    height : 250px;
  }
  
  .section9_parent__gusmP {
    height : 600px;
    flex-direction: column;
  }

}


@media (min-width: 1025px) and (max-width: 1648px) {
  .section9_parent__gusmP{
    height:600px;
  }
  
  .section9_container__x9WR6 {
    flex-direction: column;
  }

  .section9_image-click__5XmWR {
    width : 80px;
  }

  .section9_textboxA__LVJ-I {
    font-size: 24px;
  }

  .section9_textboxB__Jigxv {
    font-size: 20px;
  }

  .section9_image-logo__OmsBX {
    width : 200px;
  }

  .section9_text-1__EOwPt {
    color: black;
    font-family: 'thefaceshop_inklipquid';
    font-size: 35px;
    letter-spacing: 5px;
    line-height: 0;
  }

  .section9_top__SHJsz {
    height : 250px;
  }
}

@media (min-width: 1649px) {
  .section9_container__x9WR6 {
    height : 500px;
    justify-items: center;
  }

  .section9_child__ej\\+5e {
    flex: 5% 1;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */
  }
  
  .section9_top__SHJsz {
    width: 30%;
  }

  .section9_parent__gusmP {
    width : 70%;
    height : 100%;
  }

  .section9_image-click__5XmWR {
    width : 80px;
  }
  
  .section9_image-logo__OmsBX {
    width : 350px;
  }

  .section9_text-1__EOwPt {
    line-height: 0;
  }

  .section9_textboxB__Jigxv {
    font-size: 18px;
    line-height: 1.5;
  }

}`, "",{"version":3,"sources":["webpack://./src/Sections/section9.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC,EAAE,aAAa;EACpD,+DAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,oBAAoB;AACtB;;;;AAIA,QAAQ;AACR;EACE,uKAAqK,EAAE,cAAc;EACrL,mCAAmC;EACnC,+CAA+C;EAC/C,kDAAkD;EAClD,kBAAkB,YAAY,cAAc;EAC5C,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,kBAAkB,YAAY,cAAc;EAC5C,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;;AAGA;EACE,aAAa,iBAAiB,gBAAgB;AAChD;;;AAGA,WAAW;AACX;EACE,aAAa,iBAAiB,sCAAsC;EACpE,WAAW,iBAAiB,UAAU;EACtC,kBAAkB,YAAY,cAAc;EAC5C,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,yDAAsD;EACtD,8BAA8B;AAChC;;AAEA;EACE,yDAAsD;;AAExD;;AAEA;EACE,yDAAsD;;AAExD;;AAEA;EACE,UAAU;EACV,yCAAyC,EAAE,gBAAgB;AAC7D;;AAEA;EACE,UAAU;EACV,2CAA2C,EAAE,kBAAkB;AACjE;;AAEA;EACE,kBAAkB,EAAE,yBAAyB;EAC7C,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB,EAAE,yBAAyB;EAC7C,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;AAEF;;;AAGA;EACE;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,qCAAqC;IACrC,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,UAAQ,cAAc,sCAAsC;EAC9D;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;AAEF","sourcesContent":["@font-face {\n  font-family: 'thefaceshop_inklipquid'; /* 폰트 이름 지정 */\n  src: url('/src/fonts/thefaceshop_inklipquid.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n\n.container {\n  display: flex;\n}\n\n.text-1 {\n  color: black;\n  font-family: 'thefaceshop_inklipquid';\n  font-size: 65px;\n  letter-spacing: 10px;\n}\n\n\n\n/* top */\n.top {\n  background-image: url('/public/images/promise.png'), linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url('/public/images/TexturizerDefault.png'); /* 패턴 이미지 경로 */\n  background-size: 200px, 100%, 100px;\n  background-repeat: no-repeat, no-repeat ,repeat;\n  background-position: right bottom, center , center;\n  text-align: center;           /* 텍스트 중앙 정렬 */  \n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* top */\n.top-contents {\n  text-align: center;           /* 텍스트 중앙 정렬 */  \n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n\n.parent {\n  display: flex;                /* Flexbox로 배치 */\n}\n\n\n/* 자식 div */\n.child {\n  flex: 1 1 40%;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */\n  padding: 5%;                /* 내부 여백 */\n  text-align: center;           /* 텍스트 중앙 정렬 */\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: relative;  \n}\n\n.child1 {\n  background-image: url('/public/images/layout09-1.jpg');\n  transition: all 1s ease-in-out;\n}\n\n.child2 {\n  background-image: url('/public/images/layout09-2.jpg');\n  \n}\n\n.child3 {\n  background-image: url('/public/images/layout09-3.jpg');\n  \n}\n\n.fadeIn {\n  opacity: 1;\n  transform: translate(-50%, -50%) scale(1); /* 나타날 때 스케일 1 */\n}\n\n.fadeOut {\n  opacity: 0;\n  transform: translate(-50%, -50%) scale(0.9); /* 사라질 때 스케일 0.9 */\n}\n\n.textboxA {\n  position: absolute; /* 텍스트들이 같은 위치에 겹치도록 설정 */\n  top: 50%;\n  left: 50%;\n  width : 100%;\n  font-size: 24px;\n  color: white;\n  font-weight: 700;\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.textboxB {\n  position: absolute; /* 텍스트들이 같은 위치에 겹치도록 설정 */\n  top: 50%;\n  left: 50%;\n  width : 100%;\n  font-size: 14px;\n  color: white;\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.textboxAblack {\n  color: black;\n}\n\n.textboxBblack {\n  color: black;\n}\n\n@media (max-width: 1024px) {\n  .child {\n    height: 100%;\n  }\n  \n  .container {\n    flex-direction: column;\n  }\n\n  .image-click {\n    width : 40px;\n  }\n\n  .textboxA {\n    font-size: 18px;\n  }\n\n  .textboxB {\n    font-size: 16px;\n  }\n\n  .image-logo {\n    width : 200px;\n  }\n\n  .text-1 {\n    color: black;\n    font-size: 35px;\n    letter-spacing: 5px;\n    line-height: 0;\n  }\n\n  .top {\n    height : 250px;\n  }\n  \n  .parent {\n    height : 600px;\n    flex-direction: column;\n  }\n\n}\n\n\n@media (min-width: 1025px) and (max-width: 1648px) {\n  .parent{\n    height:600px;\n  }\n  \n  .container {\n    flex-direction: column;\n  }\n\n  .image-click {\n    width : 80px;\n  }\n\n  .textboxA {\n    font-size: 24px;\n  }\n\n  .textboxB {\n    font-size: 20px;\n  }\n\n  .image-logo {\n    width : 200px;\n  }\n\n  .text-1 {\n    color: black;\n    font-family: 'thefaceshop_inklipquid';\n    font-size: 35px;\n    letter-spacing: 5px;\n    line-height: 0;\n  }\n\n  .top {\n    height : 250px;\n  }\n}\n\n@media (min-width: 1649px) {\n  .container {\n    height : 500px;\n    justify-items: center;\n  }\n\n  .child {\n    flex: 5%;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */\n  }\n  \n  .top {\n    width: 30%;\n  }\n\n  .parent {\n    width : 70%;\n    height : 100%;\n  }\n\n  .image-click {\n    width : 80px;\n  }\n  \n  .image-logo {\n    width : 350px;\n  }\n\n  .text-1 {\n    line-height: 0;\n  }\n\n  .textboxB {\n    font-size: 18px;\n    line-height: 1.5;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `section9_container__x9WR6`,
	"text-1": `section9_text-1__EOwPt`,
	"top": `section9_top__SHJsz`,
	"top-contents": `section9_top-contents__UHOoF`,
	"parent": `section9_parent__gusmP`,
	"child": `section9_child__ej+5e`,
	"child1": `section9_child1__eNmvT`,
	"child2": `section9_child2__5pvFc`,
	"child3": `section9_child3__tGkg2`,
	"fadeIn": `section9_fadeIn__aC1I0`,
	"fadeOut": `section9_fadeOut__FGHNq`,
	"textboxA": `section9_textboxA__LVJ-I`,
	"textboxB": `section9_textboxB__Jigxv`,
	"textboxAblack": `section9_textboxAblack__iVPJt`,
	"textboxBblack": `section9_textboxBblack__-PskW`,
	"image-click": `section9_image-click__5XmWR`,
	"image-logo": `section9_image-logo__OmsBX`
};
export default ___CSS_LOADER_EXPORT___;
